const sortGwpByThresholdDesc = (gwpProducts) =>
  gwpProducts.sort((a, b) => b.gwpThreshold - a.gwpThreshold);
const nextReachedGwpProducts = (newCartValue, gwpProducts) =>
  gwpProducts.filter((p) => p.gwpThreshold <= newCartValue);

const nextWithStock = (reachedGwpProducts) =>
  reachedGwpProducts.reduce((curr, next) => (next.soldOut ? curr : next), null);

const differenceWithGwpInCart = (
  gwpInCart,
  nextReachedGwpProductList,
  gwpProducts
) => {
  const gwpProductsSize = gwpProducts.length;
  const reachedWithStock = nextWithStock(nextReachedGwpProductList);
  const isAlreadyInCart =
    nextReachedGwpProductList &&
    nextReachedGwpProductList[0] &&
    nextReachedGwpProductList[0].defaultVariantId ===
      gwpInCart.defaultVariantId;

  const doCalculateDifference = () => {
    const gwpIndex = gwpProducts.findIndex(
      (p) => p.defaultVariantId === gwpInCart.defaultVariantId
    );
    const reachedGwpIndex = gwpProducts.findIndex(
      (p) => reachedWithStock && p.id === reachedWithStock.id
    );
    return reachedWithStock
      ? gwpIndex - reachedGwpIndex
      : gwpIndex - gwpProductsSize;
  };
  return isAlreadyInCart ? 0 : doCalculateDifference();
};

const isThereABetterMatching = (
  gwpProducts,
  variantId,
  subtotal,
  gwpInCart
) => {
  const reachable = nextReachedGwpProducts(
    subtotal,
    sortGwpByThresholdDesc(gwpProducts)
  ).find(
    (el) =>
      !el.soldOut ||
      (el.soldOut &&
        gwpInCart &&
        el.defaultVariantId === gwpInCart.defaultVariantId)
  );
  return reachable && reachable.defaultVariantId !== variantId;
};

export {
  sortGwpByThresholdDesc,
  nextWithStock,
  nextReachedGwpProducts,
  differenceWithGwpInCart,
  isThereABetterMatching,
};
